import * as React from "react";
import Swiper from "react-id-swiper";

import "react-id-swiper/lib/styles/scss/swiper.scss";
import "./image-gallery.scss";

const params = {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
};

interface IImageGalleryProps {
  images: string[];
}
export const ImageGallery: React.FC<IImageGalleryProps> = ({ images }) => {
  if (!images.length) {
    return null;
  }

  return (
    <Swiper {...params}>
      {images.map(image => (
        <div className="swiper-slide" key={image}>
          <img src={image} alt="" />
        </div>
      ))}
    </Swiper>
  );
};
